/** The display metadata the backup stamps on a channel's folder in the snapshot index. */
interface Microsoft365TeamsMessageAttributes {
  conversationName?: string;
  membershipType?: string;
}

export function parseMicrosoft365TeamsMessageAttributes(
  attributes?: string
): Microsoft365TeamsMessageAttributes {
  if (!attributes) {
    return {};
  }
  try {
    const raw: Record<string, unknown> = JSON.parse(attributes);
    const str = (key: string) =>
      typeof raw[key] === 'string' ? raw[key] : undefined;
    return {
      conversationName: str('conversation_name'),
      membershipType: str('m365_teams_membership_type'),
    };
  } catch {
    return {};
  }
}
